import { render, staticRenderFns } from "./outbound-call-voicemail-icon.vue?vue&type=template&id=2c1d1c0e"
import script from "./outbound-call-voicemail-icon.vue?vue&type=script&lang=js"
export * from "./outbound-call-voicemail-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports